import { render, staticRenderFns } from "./GoBroadToGoNarrow8.vue?vue&type=template&id=4247e090&scoped=true&"
import script from "./GoBroadToGoNarrow8.vue?vue&type=script&lang=js&"
export * from "./GoBroadToGoNarrow8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4247e090",
  null
  
)

export default component.exports